import { ajaxSend } from 'api/api';
import { dataUriToFile } from 'utils/file/dataUriToFile';

import type {
  AddUserPayload,
  AddUserResponse,
  GetPresignedPayload,
  GetPresignedResponse,
  GetUserPayload,
  GetUserResponse,
  ReadCompaniesPayload,
  ReadCompaniesResponse,
  UpdateUserPayload,
  UpdateUserResponse,
  ValidateEmailResponse,
  ValidatePhoneNumberResponse,
} from './userModalApi.types';

/**
 * TODO [TEAMS-6857]: When RTK Q is ready, this function should be
 * removed/replaced
 */

const base = '/v1/users';
export function getUser(payload: GetUserPayload): Promise<GetUserResponse> {
  const { userId } = payload;
  return ajaxSend<GetUserResponse>({ path: `${base}/${userId}` });
}

export function addUser(user: AddUserPayload): Promise<AddUserResponse> {
  return ajaxSend({
    method: 'POST',
    path: base,
    data: user,
  });
}

// TODO [TEAMS-6857]: When RTK Q is ready, this function should be removed/replaced
// and "companies select" in "userModal" should be paginated/infinite scrolled
export function readCompanies(
  url: ReadCompaniesPayload = null,
): Promise<ReadCompaniesResponse> {
  const path =
    url === null || url === undefined ? 'limit=1000' : url.split('?').pop();

  return ajaxSend<ReadCompaniesResponse>({ path: `/v1/companies?${path}` });
}

export function getPresigned(
  payload: GetPresignedPayload,
): Promise<GetPresignedResponse> {
  return ajaxSend({
    path: '/v1/uploads/presigned_url/user_avatar',
    method: 'POST',
    data: {
      pretty_name: payload.file.name,
      content_type: payload.file.type,
    },
  });
}

// Upload avatar
export function uploadAvatar(payload: {
  file: File;
  upload_url: string;
}): Promise<void> {
  return ajaxSend({
    method: 'PUT',
    headers: {
      authorization: null,
      // NOTE: contentType is currently restricted to '"application/json" | "multipart/form-data" | null | undefined
      contentType: payload.file.type as any,
    },
    data: payload.file,
    path: payload.upload_url,
  });
}

export const presignAndUploadAvatar = async (url: string): Promise<string> => {
  const file = await dataUriToFile(url, 'avatar');
  const presignedResponse = await getPresigned({ file });
  await uploadAvatar({
    file,
    upload_url: presignedResponse.data.upload_url,
  });

  return presignedResponse.data.download_url;
};

export function validateEmail(email: string): Promise<ValidateEmailResponse> {
  return ajaxSend({
    path: `/v1/emails/validate/${email}`,
  });
}

export function validatePhoneNumber(
  phoneNumber: string,
): Promise<ValidatePhoneNumberResponse> {
  return ajaxSend({
    path: `/v1/numbers/validate/${phoneNumber}`,
  });
}

export function updateUser(
  payload: UpdateUserPayload,
): Promise<UpdateUserResponse> {
  return ajaxSend({
    method: 'PATCH',
    path: `${base}/${payload.userId}`,
    data: payload.patch,
  });
}
